<template>
  <v-row dense>
    <v-col cols="12" class="mt-0">
      <v-row dense>
        <!-- ISSUE-LIST  [LEFT]-->
        <v-col dense cols="6" class="pr-4">
          <!-- LIST-HEADER -->
          <div class="d-flex align-center justify-space-between" style="min-height: 32px;">
            <template>
              <p v-if="hasIssue" class="font-weight-bold" >Liste des litiges</p>
              <p v-else-if="hasNoIssue" class="font-weight-bold" >Aucun litige déclaré</p>
            </template>
            <div>
              <div @click="onNewIssue()">
                <v-chip small class="cursor-pointer">
                  <v-icon small color="grey darken-1">mdi-plus</v-icon>
                  Nouveau litige
                </v-chip>
              </div>
            </div>
          </div>
          <v-divider class="my-2"/>

          <!-- LIST-CONTENT -->
          <div v-show="getIssuesForSegment(segment.value).length > 0" v-for="(segment, index) in prestaItems" :key="segment.value">
              <div v-if="canSwapPresta" class="d-flex justify-space-between align-center mb-1" :class="index !== 0 && 'mt-4'">
                <p  class="font-weight-medium"  >
                  {{segment.text}}
                </p>
                <div @click="onNewIssue(index)">
                  <v-chip small class="cursor-pointer">
                    <v-icon small color="grey darken-1">mdi-plus</v-icon>
                    Nouveau litige
                  </v-chip>
                </div>
              </div>
              <v-data-table :headers="headers"
                            :items="getIssuesForSegment(segment.value)"
                            :sort-by="['status', 'createdAt']"
                            :sort-desc="[false, true]"
                            :disable-pagination="true"
                            :hide-default-footer="true"
                            :item-class="getRowClass"
                            class="elevation-1 tbl"
                            no-data-text="Aucun litige déclaré."
                            @click:row="onIssueRowClick" >
                <template #header.id="{ header }">
                  <span class="pl-2">
                    {{ header.text }}
                  </span>
                </template>
                <template #item.id="{ value }">
                    <span class="pl-2 caption grey--text text--darken-1">
                      <span class="small-text grey--text text--lighten-1">#</span>{{ value }}
                    </span>
                </template>
                <template #item.label="{ value }">
                  <div class="d-flex align-center">
                    <span class="small-text truncate-label">
                      {{ value }}
                    </span>
                  </div>
                </template>
                <template #item.status="{ item }">
                  <PrestaIssueStatusChip x-small :value="item.status" />
                </template>
                <template #header.createdAt>
                  <v-icon color="grey">mdi-refresh</v-icon>
                </template>
                <template #item.createdAt="{ item }">
                  <div v-if="item.updatedAt" class="date-table-cell">
                    <span class="">{{ _convertDay(item.updatedAt) }}</span>
                    <span class="grey--text">{{ _convertHour(item.updatedAt) }}</span>
                  </div>
                  <div v-else class="date-table-cell">
                    <span class="">{{ _convertDay(item.createdAt) }}</span>
                    <span class="grey--text">{{ _convertHour(item.createdAt) }}</span>
                  </div>
                </template>
                <template #header.comments>
                  <v-icon color="grey">mdi-comment-processing-outline</v-icon>
                </template>
                <template #item.comments="{ value }">
                  <v-chip x-small>{{value.length}}</v-chip>
                </template>
                <template #item.actions="{item}">
                  <v-row no-gutters justify="end" class="pr-2">
                    <v-icon small class="pa-1" @click.stop="onEditIssue(item)">edit</v-icon>
                    <!-- [N] v-show false sur la possibilité de supprimer un litige -->
                    <v-icon small class="pa-1" v-show="false" @click.stop="openIssueDetail(item, true)">delete</v-icon>
                    <v-icon v-if="isRowSelected(item)" small color="blue lighten-2" class="ml-2 pa-1" @click.stop="openIssueDetail(item, false)">mdi-arrow-right-bold</v-icon>
                    <v-icon v-else small class="ml-2 pa-1" color="grey lighten-2" @click.stop="openIssueDetail(item, false)">mdi-arrow-right-bold</v-icon>
                  </v-row>
                </template>
              </v-data-table>
            </div>
        </v-col>

        <!-- ERROR -->
        <v-col dense cols="6" v-if="hasError">
          <div class="d-flex flex-column align-center justify-center elevation-1 tbl rounded" style="height:100%;">
            <p class="red--text text-center">{{error}}</p>
            <smart-btn class="mt-2" small secondary @click.native="onCancel()">
              <span>Retour</span>
            </smart-btn>
          </div>
        </v-col>
        <!-- ISSUE-DETAIL [RIGHT]-->
        <v-col dense cols="6" v-else>
          <booking-presta-issue-detail v-if="currentIssue"
             :issue="currentIssue"
             :tags="tags"
             :has-segments="canSwapPresta"
             :segment-name="currentSegmentName"
             @clear="clearCurrentIssue"
             @updated="handleUpdateComment"
             @error="handleUpdateCommentError"
             @status-update="onChangeStatus"
          />
        </v-col>
      </v-row>
    </v-col>

    <!--  DIALOGS -->
    <booking-presta-issue-edit-dialog
        v-if="edition.dialog"
        v-model="edition.dialog"
        :context="edition.context"
        :issue="edition.issue"
        :presta-items="prestaItems"
        :tags="tags"
        :initial-index="edition.initialIndex"
        :can-swap-presta="canSwapPresta"
        @done="handleIssueEdition"
    />
  </v-row>
</template>


<script>
import {get, post} from "@/utils/api";
import StatusChip from "@/components/commons/StatusChip.vue";
import PrestaIssueStatusChip from "@/components/commons/PrestaIssueStatusChip.vue";
import BookingPrestaIssueEditDialog from "@/components/commons/BookingPrestaIssueEditDialog.vue";
import BookingPrestaIssueDetail from "@/components/commons/BookingPrestaIssueDetail.vue";


export default {
  name: "BookingPrestaIssues",
  components: {BookingPrestaIssueDetail, BookingPrestaIssueEditDialog, PrestaIssueStatusChip, StatusChip},
  props: {
    prestation: {
      type: Object,
      required: true,
    },
    issues: {
      type: Array,
      required: true,
    },
  },
  emits:['reload'],
  data() {
    return {
      state: 0,
      error: null,
      tags: [{"id":1, "tag":"Type de litige 1"}],

      edition: {
        dialog: false,
        issue: null,
        context: "CREATE",
        initialIndex: 0,
      },

      currentIssue: null,

      statusForm: {
        status: null, // 'in_progress' | 'closed' | 'give_up' | null
      },

      headers: [
        { text:"N°", value:"id"},
        { text:"LIBELLÉ", value:"label"},
        { text:"STATUS", value:"status", sortable: true,
          sort: (a, b) => {
            const order = { in_progress: 0, give_up: 1, closed: 2 }
            return (order[a] ?? 999) - (order[b] ?? 999)
          }
        },
        { text: "DATES", value: "createdAt", align: 'center', sortable: true,
          sort: (a, b) => new Date(a) - new Date(b) },
        { text: "COMMENTAIRES", value: "comments", sortable: false, align: 'center' },
        { text: "ACTIONS", value: "actions", sortable: false, align: 'center' },
      ],

    }
  },
  created() {
    this.init()
  },
  computed: {
    hasError() {
      return this.error !== null
    },
    hasIssue() {
      return !this.hasError && this.issues.length > 0
    },
    hasNoIssue() {
      return !this.hasError && this.issues.length === 0
    },
    canSwapPresta() {
      return this.prestation.kind === 'TransferPrestation' && this.prestation.segments.length > 1
    },
    prestaItems() {
      if (this.prestation.kind !== 'TransferPrestation') {
        return [{
          value: this.prestation.id,
          text:  this.prestation.data.name,
          supplierAccountingName: this.prestation.supplierAccountingName ?? this.prestation.supplierName
        }]
      } else {
        return this.prestation.segments.map((p) => {
          return {
            value: p.id,
            text:  p.data.name,
            supplierAccountingName: p.supplierAccountingName ?? p.supplierName
          }
        })
      }

    },
    currentSegmentName() {
      if (!this.canSwapPresta || !this.currentIssue) { return null }
      return this.prestaItems.find(i => i.value === this.currentIssue.prestationId).text
    },
  },
  methods: {
    init() {
      this.fetchPrestationIssuesTags()
    },
    getRowClass(item) {
      if (!this.currentIssue || this.hasNoIssue) { return '' }
      return item.id === this.currentIssue.id ? 'selected-row' : ''
    },
    isRowSelected(item) {
      return this.currentIssue && item.id === this.currentIssue.id
    },
    getIssuesForSegment(segmentId) {
      return this.issues.filter(i => i.prestationId === segmentId)
    },
    fetchPrestationIssuesTags() {
      try {
        const url = `/api/prestation/prestation-issue/tags`;
        get(url).json((r) => { this.tags = r })
      } catch (e) {
        console.log("[PrestaIssue][fetchPrestationIssuesTags] error :", e)
      }
    },
    closeEditionDialog() {
      this.edition.dialog = false
      this.edition.initialIndex = 0
      this.edition.issue = null
    },
    onNewIssue(index = 0) {
      this.edition.initialIndex = index < this.prestaItems.length ? index : 0
      this.edition.context = 'CREATE'
      this.edition.dialog = true
    },
    onEditIssue(issue) {
      this.openIssueDetail(issue, false)
      this.edition.context = 'EDIT'
      this.edition.issue = issue
      this.edition.dialog = true
    },
    onDeleteIssue() {
      if (!this.currentIssue) { return }
      this.edition.context = 'DELETE'
      this.edition.issue = this.currentIssue
      this.edition.dialog = true
    },
    onCancel() {
      this.error = null
    },
    handleIssueEdition(newIssue = null) {
      this.$emit('reload')
      this.currentIssue = newIssue
      this.closeEditionDialog()
    },
    updateIssue() {
      if (!this.currentIssue) {
        this.error = 'Impossible de mettre à jour le litige actuellement.'
        return
      }

      const url = `/api/prestation/${this.currentIssue.prestationId}/prestation-issue/${this.currentIssue.id}`
      const payload = {
        tagId: this.currentIssue.tagId,
        label: this.currentIssue.label,
        comments: this.currentIssue.comments,
        status: this.statusForm.status,
      }

      post(url, payload)
          .json((r) => {
            this.$emit('reload')
            this.currentIssue = r
            this.error = null
            this.clearChangeStatus()
          })
          .catch ((e) => {
            console.log("[PrestaIssue][updateIssue] error :", e)
            this.error = 'La mise à jour du litige a rencontré un problème.'
          })

    },
    onIssueRowClick(issue) {
      this.clearChangeStatus()
      this.openIssueDetail(issue, false)
    },
    openIssueDetail(issue, toDelete = false) {
      this.currentIssue = issue
      if (toDelete) {
        this.onDeleteIssue()
      }
    },
    handleUpdateComment(updatedIssue) {
      this.$emit('reload')
      this.currentIssue = updatedIssue
    },
    handleUpdateCommentError(errorMsg) {
      this.error = errorMsg
    },
    onChangeStatus(newStatus) {
      if (!newStatus || !['in_progress', 'closed', 'give_up'].includes(newStatus)) { return }
      this.statusForm.status = newStatus
      if (newStatus !== 'in_progress') {
        const message = newStatus === 'closed' ? 'Clore le litige ?' : 'Classer le litige sans-suite ?'
        this._confirmAndRun(message, () => this.updateIssue())
      } else {
        this.updateIssue()
      }
    },
    clearChangeStatus() {
      this.statusForm.status = null
    },
    clearCurrentIssue() {
      this.currentIssue = null
    },

  },// methods <END>


}
</script>


<style scoped>
::v-deep .selected-row {
  background-color: #e3f2fd !important;
}
.cursor-pointer {
 cursor: pointer;
}

.truncate-label {
  display: inline-block;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.date-table-cell {
  display: flex;
  flex-direction: column;
  align-items: end;
  font-size: 0.6rem;
  line-height: 0.55rem;
}
</style>